import { Suspense } from 'react';

import { Outlet } from 'react-router-dom';

import { Footer } from '../template/Footer';
import { Navbar } from '../template/navbar/Navbar';
import PageLoader from '../template/PageLoader';
import { useSidebar } from '@/lib/hooks/useSidebar';
import { useViewModeStore } from '@/store';
import { Sidebar } from '../template/Sidebar';

const UserLayout = () => {
  // const location = useLocation();
  // const navigate = useNavigate();

  const { isCollapsed, toggleCollapse } = useSidebar();
  const { viewMode, setViewMode } = useViewModeStore();

  return (
    <div className="flex flex-col relative flex-auto min-h-screen min-w-0 w-full">
      <Sidebar
          viewMode={viewMode}
          setViewMode={setViewMode}
          isCollapsed={isCollapsed}
          onToggleCollapse={toggleCollapse}
        />
    {/* // <div className="flex flex-col flex-auto min-h-screen min-w-0 relative w-full"> */}
      {/* Move Navbar inside the main content area that adjusts with sidebar */}
      <div
        className={`flex-1 flex flex-col min-w-0 transition-all duration-300 ${
          isCollapsed ? "lg:ml-16" : "lg:ml-56"
        }`}
      >
      <Navbar />
      {/* <Sidebar
          viewMode={viewMode}
          setViewMode={setViewMode}
          isCollapsed={isCollapsed}
          onToggleCollapse={toggleCollapse}
        /> */}
      <div className="h-full flex flex-auto flex-col justify-between">
        <Suspense fallback={<PageLoader />}>
          <main className="relative h-full flex flex-auto flex-col p-2 sm:px-6 md:px-8 sm:py-6 container">
            <Outlet />
          </main>
        </Suspense>
        <Footer />
      </div>
      </div>
    </div>
  );
};

export default UserLayout;
